import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "altiora_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Founder impersonation — attach the short-lived persona token so the
  // backend responds as if we were that persona (auto-expires after 5 min).
  try {
    const impTok = localStorage.getItem("elia_impersonate_token");
    const impExp = parseInt(localStorage.getItem("elia_impersonate_exp") || "0", 10);
    if (impTok && impExp && Date.now() / 1000 < impExp) {
      config.headers = config.headers || {};
      config.headers["X-Altiora-Impersonate"] = impTok;
    } else if (impTok) {
      // Expired — clean up
      localStorage.removeItem("elia_impersonate_token");
      localStorage.removeItem("elia_impersonate_exp");
    }
  } catch { /* localStorage may be unavailable — safe fallback */ }
  return config;
});
